<template>
	<div class="registration">
		<navbar></navbar>

		<section class="content">
			<md-card>
				<md-card-header>
					<div class="md-title">Regisztráció</div>
					<div class="md-subhead">Profil készítése az orvosi felülethez</div>
				</md-card-header>
				<md-card-content>
					Ez a felület orvosok számára van fenntartva.
					A páciensek számára készítetett alkalmazás elérhető a Google Play és Apple App Store alkalmazásboltban.<br><br>

					<b>Publikus adatok:</b> A publikus adatokat a szoftverünket használó páciensek láthatják. Kizárólag a kék színnel jelzett mezők számítanak publikus információnak, minden más adatot kizárólag a regisztráció folyamatában használjuk a személyazonosság ellenőrzésére. A profil elfogadása utána további kapcsolati adatokat is megadhat a páciensei számára.</br>
					<b>Kötelező mezők:</b> A csillaggal jelzett adatok megadása kötelező. Ezek alapján ellenőrizzük a személyazonosságát, és 24 órán belül elkészítjük a személyre szabott profilját.</br></br>

					<form @submit.stop.prevent="registration">

						<div class="input-group">
							<label>Alap adatok</label>
							<div class="row">
								<div class="col-md-6 col-xs-12">
									<md-input-container>
										<label class="public">Név (publikus)</label>
										<md-input v-model="form.name" required ></md-input>
									</md-input-container>
								</div>
								<div class="col-md-6 col-xs-12">
									<md-input-container>
										<label>E-mail cím</label>
										<md-input v-model="form.email" required ></md-input>
									</md-input-container>
								</div>
							</div>

							<div class="row">
								<div class="col-md-6 col-xs-12">
									<md-input-container>
										<label>Telefonszám</label>
										<md-input v-model="form.doctorData.phone" required ></md-input>
									</md-input-container>
								</div>
								<div class="col-md-6 col-xs-12">
									<md-input-container>
										<label>Egészségügyi nyilvántartási szám</label>
										<md-input v-model="form.doctorData.healthcareId" required ></md-input>
									</md-input-container>
								</div>
							</div>
						</div>

						<div class="input-group">
							<label>Szakvizsga / szakvizsgák*</label>
							<div v-for="speciality of form.doctorData.specialities" class="row">
								<md-input-container class="col-md">
									<label>Szakvizsga megnevezése</label>
									<md-input v-model="speciality.name"></md-input>
								</md-input-container>
								<md-button class="md-warn" v-on:click="deleteElement(form.doctorData.specialities, speciality)">Törlés</md-button>
							</div>
							<div class="row end-xs">
								<md-button v-on:click="form.doctorData.specialities.push({name:''})" class="md-primary">
									További szakvizsga hozzáadása
								</md-button>
							</div>
						</div>

						<div class="input-group">
							<label class="public">Aktuális munkahely / munkahelyek (publikus)</label>
							<div v-for="workplace of form.doctorData.workplaces" class="row">
								<md-input-container class="col-md">
									<label>Munkahely neve</label>
									<md-input v-model="workplace.name"></md-input>
								</md-input-container>
								<md-input-container class="col-md">
									<label>Osztály / szakrendelés</label>
									<md-input v-model="workplace.department"></md-input>
								</md-input-container>
								<md-input-container class="col-md">
									<label>Beosztás</label>
									<md-input v-model="workplace.assignment"></md-input>
								</md-input-container>
								<md-button class="md-warn" v-on:click="deleteElement(form.doctorData.workplaces, workplace)">Törlés</md-button>
							</div>
							<div class="row end-xs">
								<md-button v-on:click="form.doctorData.workplaces.push({name:'', department: '', assignment: ''})" class="md-primary">
									További munkahely hozzáadása
								</md-button>
							</div>
						</div>

						<div class="input-group">
							<label class="public">Egyéb adatok (nem kötelező)</label>
							<div class="row">
								<div class="col-md-4 col-xs-12">
									<md-input-container>
										<label class="public">Jelenlegi weboldal (publikus)</label>
										<md-input v-model="form.doctorData.website"></md-input>
									</md-input-container>
								</div>
								<div class="col-md-4 col-xs-12">
									<md-input-container>
										<label class="public">Facebook oldal (publikus)</label>
										<md-input v-model="form.doctorData.facebookPageUrl"></md-input>
									</md-input-container>
								</div>
								<div class="col-md-4 col-xs-12">
									<md-input-container>
										<label class="public">Foglalkozási kör (publikus)</label>
										<md-input v-model="form.doctorData.speciality"></md-input>
									</md-input-container>
								</div>
							</div>
						</div>


						<div class="row end-xs middle-xs">
							<div>
								A regisztrációval elfogadja az adatvédelmi nyilatkozatba foglalt feltételeinket:
								<a target="_blank" href="../static/legal.pdf">
								nyilatkozat megtekintése
								</a>
								</br>
								Sikertelen regisztráció vagy hiba esetén keressen fel minket e-mailben:
								<a target="_blank" href="mailto:hello@pulmoment.com?subject=Registration">
								hello@pulmoment.com
								</a>
							</div>
							<md-button :disabled="loading" class="md-raised md-accent" type="submit">Küldés</md-button>
						</div>
					</form>

				</md-card-content>
			</md-card>
		</section>

	</div>
</template>

<script>
	import Navbar from './Navbar'
	import Api from '../../generated'

	export default {
		components: {
			Navbar
		},
		data(){
			return{
				form:{
					password: "",
					maybeDoctor: true,
					doctorData: {
						phone: undefined,
						healthcareId: undefined,
						website: undefined,
						facebookPageUrl: undefined,
						speciality: undefined,
						workplaces:[{
							name: '',
							department: '',
							assignment: ''
						}],
						specialities:[{
							name: ''
						}],
						contactEmail: undefined,
						contactPhone: undefined
					}
				},
				mailSame: false,
				phoneSame: false
			}
		},
		methods: {
			registration(){
				/* TODO: higlight errors */
				if(!this.form.name || !this.form.email || !this.form.doctorData.phone || !this.form.doctorData.healthcareId){
					this.$bus.$emit('showToast','Kérjük töltse ki a szükséges mezőket.');
				}else {
					Api.ApiClient.instance.signup(this.form, (error, data, response) => {
						if (error) {
							console.error(error);
							if(response.body.message == "err_reg_email_format"){
								this.$bus.$emit('showToast','Hibás e-mail cím, kérjük ellenőrizze!');	
							}else{
								this.$bus.$emit('showToast','Hiba történt, próbálja meg később');
							}
						} else {
							console.log(response);
							this.$bus.$emit('showToast','Köszönjük! Hamarosan felvesszük önnel a kapcsolatot.');
						}
					});
					
				}
			},
			deleteElement(from, what){
				from = _.pull(from, what);
				this.$forceUpdate();
			}
		},
		mounted(){
		}
	}
</script>

<style scoped>
	.content{
		margin: 16px;
	}
	.input-group{
		padding: 16px;
		background: #eee;
		margin-bottom: 8px;
		border-radius: 8px;
	}
	.input-group label{
		font-size: 16px;
	}
	.public{
		color: blue;
	}
	.md-checkbox{
		margin-top: 0;
	}
</style>



// WEBPACK FOOTER //
// RegistrationView.vue?4e2cce14